// Our main CSS
import '../css/app.css'
import '@splidejs/splide/css'
import Splide from '@splidejs/splide'
// layzyload and/or play/pause inline videos when they are in/out of view
const autoplaying_videos = document.querySelectorAll('video[playsinline]')

if (autoplaying_videos && autoplaying_videos.length) {
  import('./modules/inline-videos').then((module) => {
    module.default(autoplaying_videos)
  })
}

const notices = document.querySelectorAll('.js-notices')
if (notices && notices.length) {
  const buttons = document.querySelectorAll('.js-show-more')

  buttons.forEach(function (button) {
    button.addEventListener('click', function () {
      // Find the closest parent element with the class 'js-notices'
      const notice = button.closest('.js-notice')
      if (!notice) return

      // Toggle the visibility of the '.wysiwyg.hidden' div
      const hiddenContent = notice.querySelector('.js-hidden-content')
      if (hiddenContent) {
        hiddenContent.classList.toggle('hidden')
      }

      // Change the button text
      const buttonText = button.querySelector('span:first-child')
      if (buttonText) {
        buttonText.textContent =
          buttonText.textContent.trim() === 'Visa hela texten'
            ? 'Minimera texten'
            : 'Visa hela texten'
      }

      // Add or remove a class from the SVG paths
      const svgPaths = button.querySelectorAll('svg path')
      svgPaths.forEach(function (path) {
        path.classList.toggle('expanded') // Replace 'expanded' with your desired class name
      })
    })
  })
}

// Check if .splide exists and initialize on each

/*var elms = document.getElementsByClassName( 'splide' );

for ( var i = 0; i < elms.length; i++ ) {
  new Splide( elms[ i ], { autoplay: true } ).mount();
}*/

// Lots of stuff to shuffle slides, and initialize slider.

function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[array[i], array[j]] = [array[j], array[i]]
  }
  return array
}

Splide.defaults = {
  type: 'loop',
  pagination: true,
  arrows: true
}

var elms = document.getElementsByClassName('splide')

for (var i = 0; i < elms.length; i++) {
  var splideEl = elms[i]

  // Get the list element that contains the slides
  var list = splideEl.querySelector('.splide__list')

  // Get an array of the slide elements
  var slides = Array.from(list.children)

  // Shuffle the slides array
  shuffleArray(slides)

  // Remove existing slides from the DOM
  while (list.firstChild) {
    list.removeChild(list.firstChild)
  }

  // Append the shuffled slides back to the list
  slides.forEach(function (slide) {
    list.appendChild(slide)
  })

  // Initialize Splide after shuffling
  new Splide(splideEl, { autoplay: true }).mount()
}

const hamburgerButtons = document.querySelectorAll('.js-hamburger')
const mobileNavMenu = document.querySelector('.js-mobile-nav-menu')

hamburgerButtons.forEach((button) => {
  button.addEventListener('click', function () {
    this.classList.toggle('is-active')
    mobileNavMenu.classList.toggle('hidden')
    document.body.classList.toggle('overflow-hidden')
  })
})

// Ensure the script runs after the DOM is fully loaded
const copyLinkButton = document.getElementById('copy-link-button')
document.addEventListener('DOMContentLoaded', function () {
  if (copyLinkButton) {
    document.getElementById('copy-link-button').addEventListener('click', function () {
      // Copy the current URL to the clipboard
      navigator.clipboard.writeText(window.location.href).then(
        function () {
          // Success: Swap the icons
          document.getElementById('copy-icon').style.display = 'none'
          document.getElementById('checkmark-icon').style.display = 'inline'
        },
        function (err) {
          // Error handling
          console.error('Could not copy text: ', err)
        }
      )
    })
  }
})

import Macy from 'macy'
window.createMacy = Macy
var macy = document.getElementById('masonry')
if (typeof macy != 'undefined' && macy != null) {
  var macy = Macy({
    container: '#masonry',
    trueOrder: true,
    waitForImages: true,
    margin: 24,
    columns: 3,
    breakAt: {
      850: 2,
      500: 1
    }
  })

  function timeout() {
    macy.reInit()
    setTimeout(function () {
      // Do Something Here
      // Then recall the parent function to
      // create a recursive loop.
      timeout()
    }, 1000)
  }
  timeout()
}

var upcomingMacy = document.getElementById('upcoming-masonry')
if (typeof upcomingMacy != 'undefined' && upcomingMacy != null) {
  var upcomingMacy = Macy({
    container: '#upcoming-masonry',
    trueOrder: true,
    waitForImages: true,
    margin: 24,
    columns: 3,
    breakAt: {
      850: 2,
      500: 1
    }
  })

  function timeout() {
    upcomingMacy.reInit()
    setTimeout(function () {
      // Do Something Here
      // Then recall the parent function to
      // create a recursive loop.
      timeout()
    }, 1000)
  }
  timeout()
}
const podcastList = document.querySelector('.podcast-list')

if (podcastList) {
  import('./podcastList').then((module) => {
    module.default()
  })
}

const tipsForm = document.getElementById('tips-form')
if (tipsForm) {
  import('./tipsForm').then((module) => {
    module.default(tipsForm)
  })
}

const marquee = document.querySelector('.js-marquee-left')
if (marquee) {
  import('./marquee').then((module) => {
    module.default()
  })
}

document.addEventListener('DOMContentLoaded', () => {
  const articleConfig = {
    perPage: 3,
    gap: '1.5rem',
    autoplay: true,
    pauseOnHover: true,
    breakpoints: {
      1024: { perPage: 2 },
      640: { perPage: 1 }
    }
  }

  document.querySelectorAll('.js-article-splide').forEach((root) => {
    if (root.dataset.splideMounted === 'true') return

    // Måste finnas struktur
    if (!root.querySelector('.splide__track') || !root.querySelector('.splide__list')) {
      return
    }

    // Lägg på först NU så shuffle-koden (som redan kört) inte påverkar
    root.classList.add('splide')

    try {
      new Splide(root, articleConfig).mount()
      root.dataset.splideMounted = 'true'
    } catch (e) {
      console.warn('Artikel-slider init misslyckades:', e)
    }
  })
})

document.addEventListener('DOMContentLoaded', () => {
  const btn = document.getElementById('load-more-notices')
  const wrap = document.getElementById('notices-wrapper')
  if (!btn || !wrap) return

  let loading = false
  btn.addEventListener('click', () => {
    if (loading) return
    let page = parseInt(wrap.dataset.page, 12)
    const perPage = parseInt(wrap.dataset.perPage, 12)
    const maxPages = parseInt(wrap.dataset.maxPages, 12)
    const taxonomy = wrap.dataset.taxonomy || ''

    if (page >= maxPages) {
      btn.remove()
      return
    }

    loading = true
    btn.classList.add('opacity-60', 'pointer-events-none')

    const url = new URL(window.location.origin + '/wp-json/hem/v1/notices')
    url.searchParams.set('page', page + 1)
    url.searchParams.set('per_page', perPage)
    if (taxonomy) url.searchParams.set('taxonomy', taxonomy)

    fetch(url.toString())
      .then((r) => r.json())
      .then((data) => {
        if (!data || !data.html) return
        wrap.insertAdjacentHTML('beforeend', data.html)
        wrap.dataset.page = data.page
        if (!data.has_more) {
          btn.remove()
        } else {
          btn.classList.remove('opacity-60', 'pointer-events-none')
        }
      })
      .catch(() => {})
      .finally(() => {
        loading = false
      })
  })
})
